<div class="roles-list-content">
  <app-roles-list-table
    [dataArr]="roles"
    [tableFilters]="tableFilters"
    (tableFiltersUpdated)="updateTableFilters($event)">
  </app-roles-list-table>
</div>
